import { AppRouter } from './router/AppRouter'
import { AppProviders } from './store/AppProviders'

function App() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  )
}

export default App
